import { Injectable } from '@angular/core';
import { RouterOutlets } from '@rootTypes/entities/router';
import { PortalRouterService } from '../../types/portal-router-service';
import { createPortalRoute } from '../../utils/create-portal-route';

export type VendorEmployeeRoleManagerRouteData = {
  employeeId: string;
};

export const vendorEmployeeRoleManagerRoute = createPortalRoute<VendorEmployeeRoleManagerRouteData>({
  path: ':employeeId/role/manage',
  prefix: 'vendor-employees',

  outlet: RouterOutlets.DRAWER,
});

@Injectable({ providedIn: 'root' })
export class VendorEmployeeRoleManagerRouterService extends PortalRouterService<VendorEmployeeRoleManagerRouteData> {
  readonly route = vendorEmployeeRoleManagerRoute;
}
